const DEV_URL = 'http://localhost:8071/api/v1/';

const PROD_URL = '/api/v1/';

const getM8BaseURL = () => {
  return process.env.NODE_ENV === 'production' ? PROD_URL : DEV_URL;
};

export const getM8AuthURL = (path: string) => {
  return `${getM8BaseURL()}auth/${path}`;
};

export const getM8Oauth2URL = (path: string) => {
  return `${getM8BaseURL()}oauth2/${path}`;
};

export const getM8UserURL = (path: string) => {
  return `${getM8BaseURL()}user/${path}`;
};

export const getM8AdminURL = (path: string) => {
  return `${getM8BaseURL()}admin/${path}`;
};

export const getM8PartnerURL = (path: string) => {
  return `${getM8BaseURL()}partner/${path}`;
};
